import {createReducer, on} from '@ngrx/store';
import {createEntityAdapter, EntityAdapter, EntityState} from '@ngrx/entity';
import {ProcedureDiagram} from './procedure-diagram.model';
import * as ProcedureDiagramActions from './procedure-diagram.actions';

export const procedureDiagramsFeatureKey = 'procedureDiagrams';

export interface State extends EntityState<ProcedureDiagram> {
  // additional entities state properties
}

export const adapter: EntityAdapter<ProcedureDiagram> = createEntityAdapter<ProcedureDiagram>();

export const initialState: State = adapter.getInitialState({
  // additional entity state properties
});

export const reducer = createReducer(
  initialState,
  on(ProcedureDiagramActions.addProcedureDiagram,
    (state, action) => adapter.addOne(action.procedureDiagram, state)
  ),
  on(ProcedureDiagramActions.upsertProcedureDiagram,
    (state, action) => adapter.upsertOne(action.procedureDiagram, state)
  ),
  on(ProcedureDiagramActions.addProcedureDiagrams,
    (state, action) => adapter.addMany(action.procedureDiagrams, state)
  ),
  on(ProcedureDiagramActions.upsertProcedureDiagrams,
    (state, action) => adapter.upsertMany(action.procedureDiagrams, state)
  ),
  on(ProcedureDiagramActions.updateProcedureDiagram,
    (state, action) => adapter.updateOne(action.procedureDiagram, state)
  ),
  on(ProcedureDiagramActions.updateProcedureDiagrams,
    (state, action) => adapter.updateMany(action.procedureDiagrams, state)
  ),
  on(ProcedureDiagramActions.deleteProcedureDiagram,
    (state, action) => adapter.removeOne(action.id, state)
  ),
  on(ProcedureDiagramActions.deleteProcedureDiagrams,
    (state, action) => adapter.removeMany(action.ids, state)
  ),
  on(ProcedureDiagramActions.loadProcedureDiagrams,
    (state, action) => adapter.setAll(action.procedureDiagrams, state)
  ),
  on(ProcedureDiagramActions.clearProcedureDiagrams,
    state => adapter.removeAll(state)
  ),
);

export const {
  selectIds,
  selectEntities,
  selectAll,
  selectTotal,
} = adapter.getSelectors();
